import Cookies from 'js-cookie'
import getURLSearchParam from './base/url'
import Agent from './agent'

// 美团点评 KNB.login 登陆前后 cookie 行为现状调查
// https://km.sankuai.com/page/124286917
export default {
  // https://docs.sankuai.com/lx/web/uuid/
  get uuid(): string {
    let uuid
    // 优先从query读，小程序和app会在query上带
    uuid = process.env.VUE_APP_UUID || getURLSearchParam('uuid')
    if (!uuid && Agent.dianping) {
      uuid = Cookies.get('dpid') || Cookies.get('_lxsdk_dpid')
    }
    if (!uuid) {
      uuid =
        Cookies.get('webNewUuid') ||
        Cookies.get('iuuid') ||
        Cookies.get('uuid') ||
        Cookies.get('_lxsdk_cuid') ||
        Cookies.get('_lxsdk') ||
        Cookies.get('unionid')
    }
    if (!uuid) {
      uuid = 'x-x-x-x-x'.replace(/x/g, () => Math.random().toString(16).slice(3)).slice(0, 58)
    }
    return uuid
  },
  get userId(): number {
    // 仅上报用
    return Number(getURLSearchParam('userId') || getURLSearchParam('userid') || -1)
  },
}
